
import { branchGSTGetActions } from './branchGSTVerification';

const initialState = {
  Gst: [],
  error: ""

};

const GstReducer = (state = initialState, action) => {
  switch (action.type) {
    case branchGSTGetActions.FETCH_BRANCH_GST_GET_LIST_SUCCESS:
      return {

        Gst: action.payload.data

      };

    case branchGSTGetActions.FETCH_BRANCH_GST_GET_LIST_ERROR:
      return {
        ...state,
        Gst: [],
        error: action.payload

      };




    default:
      return state;
  }
};

export default GstReducer;
